type TimeUnit = 'ms' | 'seconds' | 'minutes' | 'hours' | 'days';

export function getTimeDifference(
    previousTimestamp: number,
    unit: TimeUnit = 'days'
): number {
    const now = Date.now();
    const diff = now - previousTimestamp;

    switch (unit) {
        case 'ms':
            return diff;
        case 'seconds':
            return Math.floor(diff / 1000);
        case 'minutes':
            return Math.floor(diff / (1000 * 60));
        case 'hours':
            return Math.floor(diff / (1000 * 60 * 60));
        case 'days':
            return Math.floor(diff / (1000 * 60 * 60 * 24));
        default:
            return diff;
    }
}
